@let headerAvatar = avatarUrl() | bearerImage | async;
<p-avatar (click)="avatarMenu.toggle($event)"
          [label]="headerAvatar ? '' : (currentUser()?.initials || '')"
          [image]="headerAvatar ?? undefined"
          class="cursor-pointer"
          shape="circle"
          size="large"/>
<p-popover #avatarMenu>
  <div class="flex flex-col min-w-40">
    <div (click)="editProfile(); avatarMenu.hide()"
         class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 cursor-pointer">
      <i class="pi pi-user text-gray-600"></i>
      <span class="text-sm">{{ 'action.edit-profile' | translate }}</span>
    </div>
    <div (click)="logout()"
         class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-50 cursor-pointer text-red-600">
      <i class="pi pi-sign-out"></i>
      <span class="text-sm">{{ 'action.logout' | translate }}</span>
    </div>
  </div>
</p-popover>

@if (this.isFormDisplayed()) {
  <elcia-dialog (onAction)="saveProfile()" (onClose)="closeDialog()" [size]="'small'"
                [isActionLoading]="profileCommand.updateProfileMutation.isPending()"
                [title]="'app.my-profile' | translate">
    <div class="flex flex-col gap-8">

      <div class="flex flex-col items-center gap-3">
        @let dialogAvatar = avatarPreview() ?? (avatarUrl() | bearerImage | async);
        <p-avatar [label]="dialogAvatar ? '' : (currentUser()?.initials || '')"
                  [image]="dialogAvatar ?? undefined"
                  shape="circle"
                  size="xlarge"/>
        <input #avatarInput accept="image/*" class="hidden" type="file"
               (change)="onAvatarSelected($event)"/>
        <button (click)="avatarInput.click()"
                class="text-sm text-primary-500 hover:underline cursor-pointer"
                type="button">
          {{ 'action.change-avatar' | translate }}
        </button>
      </div>

      <div class="flex gap-4">
        <elcia-text-input [control]="this.fg.controls.firstName" [label]="'user.first-name' | translate"/>
        <elcia-text-input [control]="this.fg.controls.lastName" [label]="'user.last-name' | translate"/>
        <elcia-local-dropdown [control]="this.fg.controls.locale"/>
      </div>

    </div>
  </elcia-dialog>
}
